var map = {
	"./img_1.jpg": 30703,
	"./img_10.png": 10215,
	"./img_2.jpg": 36911,
	"./img_3.jpg": 48273,
	"./img_4.jpg": 75164,
	"./img_5.jpg": 75265,
	"./img_6.jpg": 75720,
	"./img_7.png": 62429,
	"./img_8.jpg": 61918,
	"./img_9.jpg": 39366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2015;